import { Controller } from "@hotwired/stimulus"

// Handles the bride/groom side pill toggle buttons on guest forms
export default class extends Controller {
  static targets = ["brideBtn", "groomBtn", "input"]

  static classes = ["brideActive", "groomActive", "inactive"]

  connect() {
    this.updateDisplay()
  }

  toggle(event) {
    const value = event.params.value
    const currentValue = this.inputTarget.value

    this.inputTarget.value = currentValue === value ? "" : value
    this.updateDisplay()
  }

  updateDisplay() {
    const value = this.inputTarget.value

    this.applyInactive(this.brideBtnTarget)
    this.applyInactive(this.groomBtnTarget)

    if (value === "bride") {
      this.applyActive(this.brideBtnTarget, "bride")
    } else if (value === "groom") {
      this.applyActive(this.groomBtnTarget, "groom")
    }
  }

  applyInactive(btn) {
    btn.classList.remove(
      "bg-pink-50", "text-pink-800", "border-pink-300",
      "bg-blue-50", "text-blue-800", "border-blue-300"
    )
    btn.classList.add("bg-white", "text-gray-500", "border-gray-200")
  }

  applyActive(btn, side) {
    btn.classList.remove("bg-white", "text-gray-500", "border-gray-200")

    if (side === "bride") {
      btn.classList.add("bg-pink-50", "text-pink-800", "border-pink-300")
    } else {
      btn.classList.add("bg-blue-50", "text-blue-800", "border-blue-300")
    }
  }
}
